import { Box, Button, Flex, HStack, Image, VStack } from '@chakra-ui/react';
import { IPromotion } from '@partiu/api/types';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { FaRegStar } from 'react-icons/fa6';
import { MdLocationPin } from 'react-icons/md';
import { useTheme } from '../../contexts/ThemeProvider';
import { Text } from '../atoms/Text';

export function Promotion({
  promotion,
  onClick,
  isMobile,
  isFullWidth,
  isCartaz,
  width,
}: {
  promotion: IPromotion;
  onClick?: (url: string) => void;
  isMobile: boolean;
  isCartaz?: boolean;
  isFullWidth?: boolean;
  width?: string;
}) {
  const { colors, id } = useTheme();

  if (promotion?.mode === 'online') {
    if (promotion?.value === 'null') {
      return (
        <Box
          bg="#ffffff"
          boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
          borderRadius={16}
          width={isFullWidth ? '100%' : width || '100%'}
          cursor={'pointer'}
          maxWidth={isFullWidth ? '100%' : isMobile ? width || '180px' : '300px'}
          overflow={'hidden'}
        ></Box>
      );
    }
    return (
      <Box width={'100%'}>
        <Box
          bg="#ffffff"
          boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
          sx={{
            '&:hover': {
              textDecoration: 'none',
            },
          }}
          borderRadius={16}
          width={isFullWidth ? '100%' : width || '100%'}
          cursor={'pointer'}
          maxWidth={isFullWidth ? '100%' : isMobile ? width || '180px' : '300px'}
          overflow={'hidden'}
          onClick={() =>
            onClick ? onClick(`/vantagens/detalhes/${promotion.mode}/${promotion.id.split('_')[1]}`) : null
          }
        >
          <Box padding="4px" borderRadius={16} width={'100%'} overflow="hidden" position="relative">
            <Image
              src={promotion.image}
              transition="0.6s"
              objectFit={'contain'}
              width={'100%'}
              padding={'10px'}
              flexShrink="0"
              overflow={'hidden'}
              height={isMobile ? '100px' : '180px'}
              borderRadius={16}
              _hover={{
                transform: 'scale(1.2)',
              }}
            />

            {promotion?.percentage > 0 && (
              <Box
                borderRadius={'100%'}
                backgroundColor={colors.primaryColor}
                position="absolute"
                width={'55px'}
                height={'55px'}
                right={'1px'}
                top={'1px'}
              >
                <Flex direction="row" height={'100%'} gap={0} align={'center'} justify={'center'}>
                  <VStack spacing={0} gap={0}>
                    <Text fontSize={9} marginLeft="auto" letterSpacing={'-0.04em'} fontWeight={'bold'} color="white">
                      Até
                    </Text>
                    <Text
                      fontSize={24}
                      letterSpacing={'-0.05em'}
                      fontWeight={'bold'}
                      fontFamily={'Glory'}
                      lineHeight={'20px'}
                      marginLeft={'5px'}
                      color="white"
                    >
                      {promotion.percentage}
                    </Text>
                  </VStack>

                  <Text
                    fontSize={9}
                    letterSpacing={'-0.04em'}
                    fontWeight={'bold'}
                    color="white"
                    sx={{ transform: 'rotate(-90deg) translate(0, -10%)' }}
                  >
                    % OFF
                  </Text>
                </Flex>
              </Box>
            )}
          </Box>
        </Box>
        <Box padding={'4px'} width={'100%'}>
          <HStack spacing={0} width="100%" align={'flex-start'} justifyContent={'space-between'}>
            <Text
              fontFamily={'Glory'}
              overflowX={'clip'}
              fontSize={18}
              noOfLines={1}
              textTransform={'capitalize'}
              fontWeight="600"
              lineHeight={'20px'}
              color={colors.primaryColor}
              wordBreak={'break-all'}
            >
              {promotion.name.toLowerCase()}
            </Text>
            <Button
              padding="0px"
              margin="0px"
              marginLeft={'auto'}
              variant={'link'}
              onClick={() =>
                onClick ? onClick(`/vantagens/detalhes/${promotion.mode}/${promotion.id.split('_')[1]}`) : null
              }
            >
              {!promotion.isFavorite ? (
                <AiOutlineHeart color="white" size={25} />
              ) : (
                <AiFillHeart color={colors.primaryColor} size={25} />
              )}
            </Button>
          </HStack>
          <Text
            fontFamily={'Glory'}
            textOverflow={'ellipsis'}
            overflowX={'clip'}
            fontSize={14}
            noOfLines={1}
            lineHeight={'20px'}
            height={'20px'}
            textTransform={'capitalize'}
            fontWeight="500"
            color="#5D6069"
            wordBreak={'break-all'}
          >
            {(promotion.category || '').toLowerCase()}
          </Text>
        </Box>
      </Box>
    );
  }

  if (promotion?.value === 'null') {
    return (
      <Box
        bg="#ffffff"
        boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
        borderRadius={16}
        width={isFullWidth ? '100%' : width || '100%'}
        cursor={'pointer'}
        maxWidth={isFullWidth ? '100%' : isMobile ? width || '180px' : '300px'}
        overflow={'hidden'}
      ></Box>
    );
  }
  return (
    <Box
      bg="#ffffff"
      sx={{
        '&:hover': {
          textDecoration: 'none',
        },
      }}
      borderRadius={16}
      width={isFullWidth ? '100%' : width || '100%'}
      cursor={'pointer'}
      maxWidth={isFullWidth ? '100%' : isMobile ? width || '180px' : '300px'}
      overflow={'hidden'}
      onClick={() => (onClick ? onClick(`/vantagens/detalhes/${promotion.mode}/${promotion.id.split('_')[1]}`) : null)}
    >
      <Box padding="5px" gap={0} width={'100%'}>
        <Box borderRadius={16} width={'100%'} overflow="hidden" position="relative">
          <Image
            src={promotion.exclusive || promotion.isNew ? promotion.coverPhoto : promotion.image}
            transition="0.6s"
            objectFit={'cover'}
            width={'100%'}
            flexShrink="0"
            overflow={'hidden'}
            borderRadius={16}
            minHeight={isMobile && isCartaz ? '250px' : '180px'}
            maxHeight={isMobile && isCartaz ? '250px' : '180px'}
            _hover={{
              transform: 'scale(1.2)',
            }}
          />
          {promotion.exclusive === id && (
            <Box
              display={'flex'}
              position={'absolute'}
              top={2}
              left={2}
              flexDirection={'row'}
              alignItems={'center'}
              gap={1}
              padding="3px"
              borderRadius="6px"
              backgroundColor={'#0000004D'}
            >
              <FaRegStar color="white" size={15} />
              <Text fontSize={12} color="white">
                Exclusivo
              </Text>
            </Box>
          )}

          {promotion?.percentage > 0 && (
            <Box
              borderRadius={'100%'}
              backgroundColor={colors.primaryColor}
              position="absolute"
              width={'55px'}
              height={'55px'}
              right={2}
              top={2}
            >
              <Flex position={'relative'} direction="row" height={'100%'} gap={0} align={'center'} justify={'center'}>
                <VStack spacing={0} gap={0}>
                  <Text fontSize={9} marginLeft="auto" letterSpacing={'-0.04em'} fontWeight={'bold'} color="white">
                    Até
                  </Text>
                  <Text
                    fontSize={25}
                    letterSpacing={'-0.05em'}
                    fontWeight={'bold'}
                    fontFamily={'Glory'}
                    lineHeight={'20px'}
                    marginLeft={'5px'}
                    color="white"
                  >
                    {promotion.percentage}
                  </Text>
                </VStack>

                <Text
                  fontSize={9}
                  letterSpacing={'-0.04em'}
                  fontWeight={'bold'}
                  color="white"
                  lineHeight={'normal'}
                  sx={{ transform: 'rotate(-90deg) translate(0, -10%)' }}
                >
                  % OFF
                </Text>
              </Flex>
            </Box>
          )}
          <Box
            position={'absolute'}
            bottom={'5px'}
            width={'100%'}
            padding="0px 10px"
            paddingRight="0px"
            gap={'5px'}
            display="flex"
          >
            <VStack spacing={0} width="60%" align={'flex-start'} justifyContent={'space-between'} flexGrow={1}>
              <HStack marginBottom={'2px'} width={'100%'} gap={0} justifyContent={'space-between'}>
                {promotion.distanceStr && promotion.distanceStr !== '0m' && (
                  <Box
                    display={'flex'}
                    flexDirection={'row'}
                    padding="3px"
                    alignItems={'center'}
                    borderRadius="6px"
                    backgroundColor={'#0000004D'}
                  >
                    <MdLocationPin color="white" size={15} />
                    <Text fontSize={12} color="white">
                      {promotion.distanceStr}
                    </Text>
                  </Box>
                )}

                <Button
                  padding="0px"
                  margin="0px"
                  marginLeft={'auto'}
                  variant={'link'}
                  onClick={() =>
                    onClick ? onClick(`/vantagens/detalhes/${promotion.mode}/${promotion.id.split('_')[1]}`) : null
                  }
                >
                  {!promotion.isFavorite ? (
                    <AiOutlineHeart color="white" size={25} />
                  ) : (
                    <AiFillHeart color={colors.primaryColor} size={25} />
                  )}
                </Button>
              </HStack>
            </VStack>
          </Box>
        </Box>

        <Text
          fontFamily={'Glory'}
          width="95%"
          textOverflow={'ellipsis'}
          overflowX={'clip'}
          fontSize={17}
          padding="0px 5px"
          noOfLines={1}
          textTransform={'capitalize'}
          fontWeight="500"
          color="#5D6069"
          wordBreak={'break-all'}
        >
          {promotion.name.toLowerCase()}
        </Text>
        {promotion.address && (
          <Text
            fontFamily={'Glory'}
            width="95%"
            textOverflow={'ellipsis'}
            overflowX={'clip'}
            fontSize={16}
            overflow={'hidden'}
            lineHeight={'16.58px'}
            textTransform={'capitalize'}
            padding="0px 5px"
            noOfLines={1}
            fontWeight="400"
            color="#5D6069"
            wordBreak={'break-all'}
          >
            {promotion.address.toLowerCase()}
          </Text>
        )}
      </Box>
    </Box>
  );
}
